<template>
	<div class="flex xs-12 wrap">
		<div class="flex wrap xs-12 min-height mb3">
			<div class="flex xs-12 md-6 xs-left xs-bottom ml2">
				<h2 class="fs7 lh125 fw7 c1 mr4">
					<j-button
						size="small"
						class="mr2"
						type="secondary"
						@click="$emit('showProposalList')"
					>
						<crm-icon name="back" size="normal" color="c5" class="mr1" />
					</j-button>
					{{ currentProposalName }}
				</h2>
			</div>
		</div>
		<div class="flex xs-12 bt1 bc7">
			<div class="flex wrap xs-12">
				<!-- LEFT: Steps -->
				<div class="xs-12 md-2 bg5 br1 bc7">
					<aeg-steps :tree="steps" @node:select="selectStep"></aeg-steps>
				</div>

				<!-- MIDDLE: Current Step -->
				<div class="xs-12 md-7 p8">
					<component :is="step" />
				</div>

				<!-- RIGHT: notes files, actions -->
				<div class="xs-12 md-3 bc7 bl1 bg5 p4">
					<case-notes-card class="mt6" />
					<case-files-card class="mt6" />
					<proposals-generated-policies class="mt6" />
					<case-actions
						class="mt6"
						:actions="[{ name: 'Get PDF File', value: 'ActionGetPdfFile' }]"
					/>
				</div>
			</div>
			<div
				class="xs-12 p1 ta3 bg4"
				style="position:fixed; bottom:0; right: 0; z-index:100;"
				@click="
					$store.commit(
						'caseManagement/SET_GOD_MODE',
						!$store.state.caseManagement.isGodMode
					)
				"
			>
				<span class="tt2 fs2 c6 fw7 cu2">
					God Mode is
					{{ $store.state.caseManagement.isGodMode == true ? "On" : "Off" }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
// CMS
import CaseFilesCard from "../CaseFilesCard"
import CaseNotesCard from "../CaseNotesCard"
import ProposalsGeneratedPolicies from "../ProposalsGeneratedPolicies.vue"
import CaseActions from "../CaseActions/CaseActions.vue"
import AegSteps from "../AegSteps.vue"
import AegTabs from "../AegTabs.vue"

import CBProposalOverview from "./CBProposalOverview"
import CBProposalPolicyholder from "./CBProposalPolicyholder"
import CBProposalInsureds from "./CBProposalInsureds"
import CBProposalBusinessNature from "./CBProposalBusinessNature"
import CBProposalEmployees from "./CBProposalEmployees"
import CBProposalStockValues from "./CBProposalStockValues"
import CBProposalOutdoorRisk from "./CBProposalOutdoorRisk"
import CBProposalOutsideLimit from "./CBProposalOutsideLimit"
import CBProposalPremisesGeneralProtection from "./CBProposalPremisesGeneralProtection"
import CBProposalBurglarAlarms from "./CBProposalBurglarAlarms"
import CBProposalSafes from "./CBProposalSafes"
import CBProposalStrongRoom from "./CBProposalStrongRoom"
import CBProposalKeysAndSpecialProtectionMeans from "./CBProposalKeysAndSpecialProtectionMeans"
import CBProposalStockRecords from "./CBProposalStockRecords"
import CBProposalLosses from "./CBProposalLosses"
import CBProposalContentsFireRate from "./CBProposalContentsFireRate"
import CBProposalReferences from "./CBProposalReferences"
import CBProposalOtherInsurance from "./CBProposalOtherInsurance"
import CBProposalMaterialFacts from "./CBProposalMaterialFacts"
import CBProposalSumInsured from "./CBProposalSumInsured"
import CBOffers from "./CBOffers"

export default {
	components: {
		CrmIcon,
		JButton,
		// Should come from CMS
		CaseFilesCard,
		CaseNotesCard,
		ProposalsGeneratedPolicies,
		CaseActions,
		AegSteps,
		AegTabs,

		CBProposalOverview,
		CBProposalPolicyholder,
		CBProposalInsureds,
		CBProposalBusinessNature,
		CBProposalEmployees,
		CBProposalStockValues,
		CBProposalOutdoorRisk,
		CBProposalOutsideLimit,
		CBProposalPremisesGeneralProtection,
		CBProposalBurglarAlarms,
		CBProposalSafes,
		CBProposalStrongRoom,
		CBProposalKeysAndSpecialProtectionMeans,
		CBProposalStockRecords,
		CBProposalLosses,
		CBProposalContentsFireRate,
		CBProposalReferences,
		CBProposalOtherInsurance,
		CBProposalMaterialFacts,
		CBProposalSumInsured,
		CBOffers
	},
	data() {
		return {
			step: "",
			// Steps
			steps: [
				{
					id: "CBProposalOverview",
					component: "CBProposalOverview",
					title: "Proposal Form",
					isSelected: true
				},
				{
					id: "CBProposalPolicyholder",
					component: "CBProposalPolicyholder",
					title: "Policyholder"
				},
				{
					id: "CBProposalInsureds",
					component: "CBProposalInsureds",
					title: "Insureds"
				},
				{
					id: "CBProposalBusinessNature",
					component: "CBProposalBusinessNature",
					title: "Business Nature"
				},
				{
					id: "CBProposalEmployees",
					title: "Employees",
					component: "CBProposalEmployees"
				},
				{
					id: "CBProposalStockValues",
					title: "Stock Values",
					component: "CBProposalStockValues"
				},
				{
					id: "CBProposalOutdoorRisk",
					title: "Outdoor Risk",
					component: "CBProposalOutdoorRisk"
				},
				{
					id: "CBProposalOutsideLimit",
					title: "Outside Limit",
					component: "CBProposalOutsideLimit"
				},
				{
					id: "CBProposalPremisesGeneralProtection",
					title: "Premises General Protection",
					component: "CBProposalPremisesGeneralProtection"
				},
				{
					id: "CBProposalBurglarAlarms",
					title: "Burglar Alarms",
					component: "CBProposalBurglarAlarms"
				},
				{
					id: "CBProposalSafes",
					title: "Safes",
					component: "CBProposalSafes"
				},
				{
					id: "CBProposalStrongRoom",
					title: "Strong Room",
					component: "CBProposalStrongRoom"
				},
				{
					id: "CBProposalKeysAndSpecialProtectionMeans",
					title: "Keys and Special Means of Protection",
					component: "CBProposalKeysAndSpecialProtectionMeans"
				},
				{
					id: "CBProposalStockRecords",
					title: "Stock Records",
					component: "CBProposalStockRecords"
				},
				{
					id: "CBProposalLosses",
					title: "Losses",
					component: "CBProposalLosses"
				},
				{
					id: "CBProposalContentsFireRate",
					title: "Contents Fire Rate",
					component: "CBProposalContentsFireRate"
				},
				{
					id: "CBProposalSumInsured",
					title: "Sum Insured",
					component: "CBProposalSumInsured"
				},
				{
					id: "CBProposalReferences",
					title: "References",
					component: "CBProposalReferences"
				},
				{
					id: "CBProposalOtherInsurance",
					title: "Other Insurance",
					component: "CBProposalOtherInsurance"
				},
				{
					id: "CBProposalMaterialFacts",
					title: "Other Material Facts",
					component: "CBProposalMaterialFacts"
				},
				{
					id: "CBOffers",
					component: "CBOffers",
					title: "Rating & Clauses"
				}
			]
		}
	},
	computed: {
		currentProposalName() {
			return (
				this.$store.state.caseManagement.proposals.find(
					proposal =>
						proposal.id === this.$store.state.caseManagement.proposalId
				)?.name || "Unnamed Proposal"
			)
		}
	},
	methods: {
		selectStep(stepToSelect) {
			// Select tab
			this.step = stepToSelect.id

			// Change selected tab
			this.steps = this.steps.map(step => ({
				...step,
				isSelected: stepToSelect.id === step.id ? true : false
			}))
		}
	},

	created() {
		this.selectStep({ id: "CBProposalOverview" })
	}
}
</script>

<style></style>
